import Content from 'components/common/Content-v2';
import MainTitle from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import AddAllyForm from 'components/forms/allies/add';
import { useIntl } from 'react-intl';
const AddMember = props => {
	const { formatMessage } = useIntl();
	return (
		<>
			<MainTitle>
				<h1>{formatMessage({ id: 'dashboard.addAlly' })}</h1>
				<LinkButton to="/admin/allies"> {formatMessage({ id: 'commons.back' })}  </LinkButton>
			</MainTitle>
			<Content>
				<AddAllyForm />
			</Content>
		</>
	);
};
export default AddMember;
